import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';

import Modal from '../Modal/Modal';
import getCalculateReport from '../../thunks/calculateReport/getCalculateReport';
import Text from '../Text/Text';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import Table from '../Table/Table';
import TableHead from '../Table/TableHead';
import TableHeadData from '../Table/TableHeadData';
import TableRow from '../Table/TableRow';
import TableBody from '../Table/TableBody';
import TableData from '../Table/TableData';

const CalculateReportModal = ({ visible, toggleVisible }) => {
  const {
    calculateReport,
    loading
  } = useSelector((state) => ({
    calculateReport: state?.getCalculateReport?.data,
    loading: state?.getCalculateReport?.loading
  }), shallowEqual);

  const [dateStart, setDateStart] = useState();
  const [dateTo, setDateTo] = useState();

  const dispatch = useDispatch();

  const onSave = () => dispatch(getCalculateReport({
    to: DateTime.fromISO(dateTo?.toISOString()).toFormat('yyyy-MM-dd'),
    from: DateTime.fromISO(dateStart?.toISOString()).toFormat('yyyy-MM-dd')
  }));

  const getUserName = () => {
    const users = [];
    Object?.keys(calculateReport)?.map((status) => status !== 'date'
      && users.push(Object?.keys(calculateReport[status])));
    return [...new Set(users?.flat())];
  };

  const columnOrder = [
    'order_part_box_by', 'order_assembled_by', 'order_packed_by', 'Reassembly', 'Sending', 'Service'
  ];

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Calculate report"
      saveText={loading ? 'Loading...' : 'Calculate'}
      onSave={onSave}
      canSave={!(dateTo && dateStart && !loading)}
      hideCloseBtn
    >
      <div className="customScroll">
        <Text text="Range:" />
        <CustomDatePicker
          placeholder="Select date range"
          startDate={dateStart}
          setStartDate={setDateStart}
          endDate={dateTo}
          setEndDate={setDateTo}
          maxDate={new Date()}
          monthsShown={1}
        />
        {calculateReport && (
          <>
            <div>
              <br />
              <br />
              <Table loading={loading}>
                <TableHead>
                  <TableRow bordered>
                    <TableHeadData>
                      User
                    </TableHeadData>
                    {columnOrder?.map((key) => <TableHeadData key={key}>{key}</TableHeadData>)}
                    <TableHeadData />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    calculateReport && (
                      getUserName()?.map((user) => (
                        <TableRow key={user}>
                          <TableData>{user}</TableData>
                          {columnOrder?.map((status) => (
                            <TableData
                              key={[status, user].join('_')}
                            >
                              {calculateReport?.[status]?.[user] || 0}
                            </TableData>
                          ))}
                          <TableData />
                        </TableRow>
                      ))
                    )
                  }
                </TableBody>
              </Table>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

CalculateReportModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func
};

CalculateReportModal.defaultProps = {
  visible: false,
  toggleVisible: () => {}
};

export default CalculateReportModal;
